import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    return Vue.http.get('/api/compras', { params: parametros }).then(response => response.data);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/compras/${id}`).then(response => response.data);
  },
  liberar: id => {
    return Vue.http.put(`/api/compras/${id}/liberar`).then(response => response.data);
  },
  permissaoLiberarCompra: (idCompra) => {
    return Vue.http.get(`/api/compras/${idCompra}/permissaoliberar`).then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/compra/servico.js